import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Terms() {
    return (
        <div id="wrapper">
            {/* Header component */}
            <Header />

            <div className="no-bottom no-top" id="content">

              

                  {/* section begin */}
                  <section id="subheader" className="minimal">
                    <div className="center-y relative text-center">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <h1>Terms of service</h1>
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* section close */}

                {/* Section begin */}
                <section aria-label="section" id="section-learn">
                    <div className="container">
                        <div className="row">
                            

                        <div>

                    </div>
                        </div>
                    </div>
                </section>
                {/* Section close */}
            </div>

            {/* Footer component */}
            <Footer />
        </div>
    );
}

export default Terms;